import React from 'react'
import { Header,BannerSection,TransformSection,Timeline,IncludedSection,RetreatCard} from '../../../components/template'
const InnerQuiet = () => {
    const heading = <span className="inline-block pl-6 md:pl-20">What’s Unique?</span>;  
    const features = [
      { icon: "🔇", text: "3 Full Days of Silence – Detox from digital distractions & mental chatter" },
      { icon: "🌀", text: "Powerful Mind-Decluttering Practices – Meditations & self-inquiry exercises" },
      { icon: "🧘‍♀️", text: "Hatha Yoga & Breathwork – Balance body & breath for deeper mindfulness" },
      { icon: "🙏", text: "Karma Yoga – Cultivate mindfulness in action through selfless service" },
      { icon: "🌿", text: "Nature Immersion – Walks, journaling, and reflection in a serene space" }
    ];
    const whatsIncludedHeading = "What’s Included?"; 

const whatsIncludedItems = [
  { icon: "🏡", title: "Comfortable & Serene Accommodation" },
  { icon: "🥗", title: "Nutritious Vegetarian Meals" },
  { icon: "🧘‍♂️", title: "Daily Yoga, Meditation & Breathwork" },
  { icon: "🌿", title: "Guided Silent Practices for Mind Detox" },
  { icon: "📝", title: "Self-Reflection & Journaling Exercises" }
];

const whatsIncludedMainImage = "/assets/innerquiet/innerquiet 7.jpg";
const whatsIncludedOverlayImage = "";

    const transformImage = "/assets/retreats/innerquiet 2.jpg"; 
const transformHeading = "Why Attend?";
const ticons = ["🌿", "🧠", "💛", "💨"];

const transformPoints = [
  <>
    <b> Inner Stillness –</b> Free yourself from mental noise & distractions
  </>,
  <>
    <b> Mental Clarity –</b> Strengthen focus, reduce overthinking, and make better decisions
  </>,
  <>
    <b> Emotional Balance –</b> Release stored stress, cultivate inner peace & mindfulness
  </>,
  <>
    <b> Energy Renewal –</b> Revitalize body & mind through yoga, breathwork & silence
  </>
];
const timeheading="Your 3 day Retreat Journey";
const icons = ["✨", "🧘‍♂️", "🏆"]; 

const journey = [
  {
    day: "Day 1",
    title: "Arriving in Stillness",
    activities: [
      "🛬 Arrival & Orientation – Settle in, learn the retreat guidelines, and embrace the silent journey.",
      "🧘‍♀️ Hatha Yoga & Grounding Breathwork – Release stress and prepare the body.",
      "🌅 Silent Sunset Meditation – Deepen awareness through mindful breathing.",
      "🛏️ Mindful Rest – Learn conscious relaxation before sleep."
    ]
  },
  {
    day: "Day 2",
    title: "Deepening Awareness",
    activities: [
      "🌄 Sunrise Hatha Yoga & Pranayama – Open energy channels & cultivate vitality.",
      "🍃 Guided Vipassana Meditation – Observe thoughts, emotions & cultivate mindfulness.",
      "🚶 Silent Nature Walk & Journaling – Connect with nature, reflect & gain clarity.",
      "🙏 Karma Yoga (Selfless Service) – Practice mindfulness through meaningful action.",
      "🌌 Night Meditation on Clarity – Unravel mental clutter & deepen awareness."
    ]
  },
  {
    day: "Day 3",
    title: "Integration & Renewal",
    activities: [
      "🌞 Morning Yoga & Breathwork – Energize and align the body & mind.",
      "💡 Mindful Reflection Session – Journal insights & create a post-retreat action plan.",
      "🌿 Final Meditation & Closing Circle – Embrace inner stillness & transition mindfully back."
    ]
  }
];
const retreats = [
  {
    // image: "assets/synnergise/.jpg",
    date: "To be announced soon",
    place: "To be announced soon",
    // price: "Starting from Rs 19,000 + Taxes",
  },
];
const mediaItems = [
  { type: "image", src: "/assets/innerquiet/innerquiet 8.jpg" },

  { type: "image", src: "/assets/innerquiet/innerquiet 9.jpg" },
  { type: "image", src: "/assets/innerquiet/innerquiet 6.jpg" },

  { type: "image", src: "/assets/innerquiet/innerquiet 3.jpg" },

  { type: "image", src: "/assets/retreats/innerquiet 5.jpg" },
  { type: "image", src: "/assets/innerquiet/innerquiet 11.JPG" },

  { type: "image", src: "/assets/innerquiet/innerquiet 2.jpg" },
  { type: "image", src: "/assets/innerquiet/INNER QUIET 4.jpg" },


]


  return (
    <>
    <div className="w-full text-center p-8 md:p-10 bg-light">
          <h1 className="text-2xl md:text-4xl  font-bold text-[#8B2218] leading-tight">
          InnerQuiet Silent Retreat
          </h1>
          <h2 className="text-lg md:text-2xl  text-[#578d48] font-bold mt-4 md:mt-14">
          🧘‍♂️ Embrace Silence, Declutter Mind, Discover Inner Peace          </h2></div>
         <section className="py-10 px-6 md:px-20 flex flex-col gap-6 bg-light items-center">
      <h2 className="text-2xl md:text-3xl font-bold text-secondary">Upcoming Retreats</h2>
      {retreats.map((retreat, index) => (
        <RetreatCard key={index} {...retreat} />
      ))}
    </section>
   
<Header
           description ={ [
            "3-day Silent Retreat to declutter mind & boost self-awareness",
            "Practices rooted in Vedanta, Raja Yoga, & Karma Yoga",
            "Led by an IITian-turned-Wellness & Mindset Coach"
          ]} 
          
          mainImage="/assets/_DSC1537.jpg"
          sideImages={["/assets/yog.jpg", "/assets/yog2.jpg"]} 
          mediaItems={mediaItems} 
          showVideo={true} 
          icons={icons}
       
        />
     
      <TransformSection  imageSrc={transformImage} altText="Transformation experience" heading={transformHeading}  points={transformPoints} ticons={ticons} />
      <BannerSection heading={heading}  features={features}/>
      <Timeline timeheading={timeheading} journey={journey}/>
      <IncludedSection heading={whatsIncludedHeading}
      mainImage={whatsIncludedMainImage}
      overlayImage={whatsIncludedOverlayImage}
      items={whatsIncludedItems}/>

    </>
  )
}

export default InnerQuiet